import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'next-i18next';
import CustomToast from '@/components/CustomToast';
import toast from 'react-hot-toast';
import useAuth from '@/hooks/useAuth';
import { useLoginModal } from '@/contexts/LoginModalContext';
import { track } from '@/lib/tracker';

export default function ConfirmationModal({
  confirmCart,
  is_edit,
  addToCart,
  addToCartLoading,
  setConfirmCart,
  childName,
  product,
  quantity
}: any) {
  const {t} = useTranslation('personalizeModal');
  const {user} = useAuth('none');
  const { setIsOpen, setProductType, setPostLoginCallback, setIsCallBack, setCurrentView, setLocation, setName } = useLoginModal();
  const {t: tAlerts} = useTranslation('alerts');
  if (!confirmCart || is_edit !== '0') return null;

  const handleConfirm = () => {
    if (!user) {
          toast.custom((t) => <CustomToast type='error' t={t} message={tAlerts('login_first')} />, {
            duration: 2500,
          });
          setProductType('1');
          setCurrentView('guest');
          
          // Create a fresh callback that uses the refs
          const loginCallback = () => {
            handleConfirm();
          };
          
          setPostLoginCallback(() => loginCallback);
          setLocation('story');
          if(setName)
            setName(childName);
          setIsOpen(true);
          setIsCallBack(true);
          return;
        }
    track({ 
      event_name: "add_to_cart",
      metadata: {product_id: product?.id , price: product?.front_pice?.amount}
    });
    addToCart();
  }

  return (
    <motion.div 
      key="confirmation-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="absolute inset-0 bg-black/40 z-[150] flex items-center justify-center"
    >
      <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center shadow-lg">
        <div className='w-full flex items-center justify-center mb-6'>
          <img src="/images/addtocart.svg" alt="Add to cart icon" className='w-12 h-12 '/>
        </div>
        <h3 className="text-lg font-semibold mb-2 px-4">
          {t('productConfrimationHeading')}
        </h3>
        <p className="text-sm text-[##52575C] px-4">
          {t('productConfrimationSubHeading')}
        </p>
        <div className="flex justify-center gap-3 mt-6 w-full">
          <button
            id="confirmation-to-add-to-cart"
            onClick={()=>{handleConfirm()}}
            disabled={addToCartLoading}
            className="bg-primary text-white px-10 py-4 rounded hover:bg-primary-700 font-medium flex items-center justify-center gap-2"
          >
            {addToCartLoading ? (
              <div className="flex items-center justify-start w-full">
                <span className="ml-2">
                  {t('productConfiramtionText')}
                </span>
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
              </div>
            ) : (
              `${t('productConfirmationAddToCart')}`
            )}
          </button>
        </div>
      </div>
    </motion.div>
  );
}